import {
  INamedTypeDocument,
  TypeGuardFn,
  type Timestamp,
} from '@principle-theorem/shared';
import { MentionResourceType } from './mention/mention';

export interface IDataChange<Data> {
  before: Data;
  after: Data;
}

export interface IStatusHistory<Status> {
  status: Status;
  updatedAt: Timestamp;
}

export type SortReturnValue = -1 | 0 | 1;

export interface IArraySorter {
  key: string;
  typeGuardFn?: TypeGuardFn<unknown>;
  sortByPath: string | string[] | ((data: unknown) => string | number);
}

export type PrincipleCreatedBy = INamedTypeDocument<
  object,
  MentionResourceType
>;
